<template>
    <div class="header" :class="opcity!=1?'opcity':''" :style="'background:rgba(49,45,42,'+opcity+')'">
        <div class="nav">
            <div class="nav-left">
                <div class="logo" @click="$router.push({path: '/'})">
                </div>
                <div v-for="(item, index) in newMenu" :key="index" class="menus" :class="{'choosing':current===index}">
                    <router-link :to="item.path">{{item.title}}</router-link>
                </div>
            </div>
            <div class="menu">

                <div class="accout menus" @mouseover="showCode" @mouseleave="hideCode">
                    <a>微信公众号</a>
                    <img v-show="codeShow" src="../assets/img/QRcode.png" alt="" style="z-index:9999">
                </div>
                <div class="menus">
                    <!--<a @click="login">教师登录</a>-->
                    <a href="http://www.geeshu.com/site/b/login" >教师登录</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
//  :class="isOpcity?'opcity': ''"
import Menu from '../plugins/Menu'
import {mapGetters} from 'vuex'
export default {
    name: "navSite",
    data(){
        return{
            Menus: Menu,
            codeShow: false,
            borderShow:false,
            current:'',
        }
    },
    computed:{
        newMenu(){
            let menu = []
            for(var i in this.Menus){
                if(!this.Menus[i].ishide){
                    menu.push(this.Menus[i])
                }
            }
            return menu
        },
        ...mapGetters([
            'opcity',
        ])
    },
    created(){
        console.log(this.opcity, this.opcity!=1)
        // console.log(this.$route)
    },
    methods: {
        showCode(){
            this.current = '';
            this.codeShow = true
        },
        hideCode() {
            this.current = '';
            this.codeShow = false
        },
        showBorder(i){
            this.current = i;
            this.borderShow = true
        },
        hideBorder(){
            this.current = '';
            this.borderShow = false
        },
        login(){
            this.current = 88;
            this.$router.push({name: 'Login'})
        },
        // change(i){
        //     this.current = i;
        // },
    }
}
</script>

<style lang="scss" scoped>
.header{
  background: #30384c;
}
.logo{
    height: 40px;
    line-height: 40px;
    width: 120px;
    background: url('../assets/img/logo.png') no-repeat center;
    background-size: 100% 100%;
    cursor: pointer;
    margin-right: 50px;
}
.opcity{
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9999;
}
.active{
    border-bottom:2px solid #fff;
}
.nav{
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    height: 100px;
    line-height: 100px;
    align-items: center;
    width: 1140px;
    .nav-left{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .menu{
        /*width: 578px;*/
    }
    .menus{
        height: 100px;
        display: inline-block;
        cursor: pointer;
        /*float: left !important;*/
        /*.router-link-exact-active{*/
            /*color:#2995e9;*/
        /*}*/
        :hover{
            border-bottom: 2px solid #fff;
        }
    }
    .choosing a{
        color:#2995e9;
    }
    a{
        // display: inline-block;
        padding: 15px 15px;
        color: #fff;
    }
}
.accout{
    display: inline-block;
    position: relative;
    img{
        position: absolute;
        left: 0px;
        top: 100px;
        width: 120px;
        z-index: 9999;
    }
}
   .border_b{
        position: absolute;
        height: 3px;
        /*background-color: #f0f0f0;*/
        vertical-align: middle;
        margin-left: -80px;
        margin-top: 88px;
    }
    .choosing{
        /*border-bottom: 3px solid #ffffff;*/
        position: relative;
    }
    .choosing::after{
        content: '';
        position: absolute;
        bottom: 1px;
        left: 0px;
        width: 100%;
        height: 2px;
        background:#fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/navSite.vue